/* LP Aura — Interactions */
(function(){
  /* Guard: this file is included by multiple sections — only run once per page */
  if(window.__lpAuraInit) return;
  window.__lpAuraInit = true;

  /* Nav scroll */
  var nav = document.querySelector('nav.lp-nav');
  if(nav){
    window.addEventListener('scroll',function(){
      nav.classList.toggle('sc', window.scrollY > 60);
    });
  }

  /* Intersection Observer — fade-in animations */
  var obsEls = document.querySelectorAll('[data-a]');
  if(obsEls.length){
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          var d = e.target.getAttribute('data-a');
          e.target.style.transitionDelay = d ? d+'s' : '0s';
          e.target.classList.add('vis');
        }
      });
    },{threshold:0.15});
    obsEls.forEach(function(el){ obs.observe(el); });
  }

  /* Counter animation */
  function animateCounter(el){
    var text = el.textContent.trim();
    var match = text.match(/^(\d+)/);
    if(!match) return;
    var target = parseInt(match[1]);
    var suffix = text.replace(match[1],'');
    var dur = 1400;
    var start = performance.now();
    function step(now){
      var t = Math.min((now - start)/dur, 1);
      var ease = 1 - Math.pow(1-t, 3);
      el.textContent = Math.round(target * ease) + suffix;
      if(t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var counterEls = document.querySelectorAll('.s-num, .rsm-n, .r-mn');
  if(counterEls.length){
    var cObs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          animateCounter(e.target);
          cObs.unobserve(e.target);
        }
      });
    },{threshold:0.4});
    counterEls.forEach(function(el){ cObs.observe(el); });
  }

  /* Product gallery thumbnail click */
  var thumbs = document.querySelectorAll('.g-thumb');
  var mainImg = document.querySelector('.g-main');
  var vidWrap = document.querySelector('.g-vid-wrap');
  var vThumb = document.querySelector('.g-vthumb');

  thumbs.forEach(function(t){
    t.addEventListener('click',function(){
      thumbs.forEach(function(x){ x.classList.remove('on'); });
      if(vThumb) vThumb.classList.remove('on');
      t.classList.add('on');
      if(mainImg) mainImg.src = t.src;
      if(mainImg) mainImg.style.display = 'block';
      if(vidWrap) vidWrap.classList.remove('active');
    });
  });

  if(vThumb){
    vThumb.addEventListener('click',function(){
      thumbs.forEach(function(x){ x.classList.remove('on'); });
      vThumb.classList.add('on');
      if(mainImg) mainImg.style.display = 'none';
      if(vidWrap) vidWrap.classList.add('active');
      var vid = vidWrap.querySelector('video');
      if(vid) vid.play();
    });
  }

  /* FAQ accordion */
  document.querySelectorAll('.faq-q').forEach(function(q){
    q.addEventListener('click',function(){
      var item = q.closest('.faq-item');
      var wasOpen = item.classList.contains('open');
      /* Close all */
      document.querySelectorAll('.faq-item').forEach(function(fi){
        fi.classList.remove('open');
      });
      if(!wasOpen) item.classList.add('open');
    });
  });

  /* Rating bar fill animation */
  var ratingBar = document.querySelector('.testi-rating-bar');
  if(ratingBar){
    var ratingObs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          var fills = e.target.querySelectorAll('.trb-fill');
          fills.forEach(function(f){
            var w = f.getAttribute('data-width');
            if(w) f.style.width = w + '%';
          });
          ratingObs.unobserve(e.target);
        }
      });
    },{threshold:0.3});
    ratingObs.observe(ratingBar);
  }

  /* Sticky CTA */
  var shopSection = document.getElementById('shop');
  var stickyCta = document.getElementById('stickyCta');
  if(shopSection && stickyCta){
    var stickyObs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        stickyCta.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    },{rootMargin:'-80px 0px 0px 0px'});
    stickyObs.observe(shopSection);
  }

  /* ── Hero video autoplay ──
     <video autoplay muted loop playsinline> is allowed on every mobile browser,
     but the OS can still hold it until the shopper interacts: iOS Low Power
     Mode, iOS Settings › Accessibility › Motion › "Auto-Play Video Previews"
     off, Android battery / data savers. Retry on the first touch, click or key,
     when the tab becomes visible again, and when the hero scrolls into view. */
  var heroVideos = document.querySelectorAll('.h-vid-col video');
  heroVideos.forEach(function(v){
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    function tryPlay(){
      if(!v.paused) return;
      var p = v.play();
      if(p && typeof p.catch === 'function') p.catch(function(){ /* blocked until a gesture — retried below */ });
    }
    var gestures = ['touchstart','touchend','click','keydown'];
    function onGesture(){ tryPlay(); }
    function stopListening(){ gestures.forEach(function(g){ document.removeEventListener(g, onGesture, true); }); }
    gestures.forEach(function(g){ document.addEventListener(g, onGesture, {capture:true, passive:true}); });
    v.addEventListener('playing', stopListening);
    document.addEventListener('visibilitychange', function(){ if(!document.hidden) tryPlay(); });
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(en.isIntersecting) tryPlay(); });
      },{threshold:0.1}).observe(v);
    }
    tryPlay();
  });

  /* ── Add-to-cart CTAs (snippets/lp-cta.liquid) ──
     Adds the button's variant with /cart/add.js and opens the theme cart drawer
     (same section-rendering flow as product-form.js) so the shopper stays on
     the page. Falls back to the button's URL (today's checkout link) or /cart
     when the drawer is missing or the request fails. */
  function lpCartDrawer(){
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }
  function lpCtaFallback(btn){
    window.location.href = btn.getAttribute('data-fallback-url') || (window.routes && window.routes.cart_url) || '/cart';
  }
  function lpCtaError(btn, message){
    var el = btn.nextElementSibling;
    if(!el || !el.classList.contains('lp-cta-error')){
      el = document.createElement('div');
      el.className = 'lp-cta-error';
      el.setAttribute('role', 'alert');
      btn.insertAdjacentElement('afterend', el);
    }
    el.textContent = message;
  }
  function lpAddToCart(btn){
    if(btn.classList.contains('is-loading')) return;
    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if(!variantId){ lpCtaFallback(btn); return; }
    var cart = lpCartDrawer();
    var body = { id: variantId, quantity: 1 };
    var plan = parseInt(btn.getAttribute('data-selling-plan'), 10);
    if(plan) body.selling_plan = plan;
    if(cart && typeof cart.getSectionsToRender === 'function'){
      body.sections = cart.getSectionsToRender().map(function(s){ return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
    .then(function(r){ return r.json(); })
    .then(function(res){
      if(res.status){
        lpCtaError(btn, res.description || res.message || 'Sorry, this item could not be added to your cart.');
        return;
      }
      var afterAdd = btn.getAttribute('data-after-add');
      if(afterAdd === 'checkout'){ window.location.href = '/checkout'; return; }
      if(afterAdd === 'cart'){ window.location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
      if(cart && typeof cart.renderContents === 'function' && res.sections){
        if(typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'){
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lp-cta', productVariantId: variantId });
        }
        cart.classList.remove('is-empty');
        if(typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
        cart.renderContents(res);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    })
    .catch(function(err){
      if(window.console) console.error('[lp-cta] add to cart failed, falling back to the button URL', err);
      lpCtaFallback(btn);
    })
    .finally(function(){
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    });
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('[data-lp-atc]');
    if(!btn) return;
    e.preventDefault();
    lpAddToCart(btn);
  });
})();
